import { all } from "redux-saga/effects"
import { appAccountSaga } from "./app-phuhuynh/appAccountSaga"
import { appMenuNhomSaga } from "./app-phuhuynh/appMenuNhomSaga"
import { appMenuSaga } from "./app-phuhuynh/appMenuSaga"
import { appMenuTruongSaga } from "./app-phuhuynh/appMenuTruongSaga"
import { appXinNghiSaga } from "./app-phuhuynh/appXinNghiSaga"
import { authSaga } from "./authSaga"
import { baiTapKetQuaLopSaga } from "./bai-tap/baiTapKetQuaLopSaga"
import { baiTapKetQuaSaga } from "./bai-tap/baiTapKetQuaSaga"
import { baiTapSaga } from "./bai-tap/baiTapSaga"
import { baiTapTypeSaga } from "./bai-tap/baiTapTypeSaga"
import { baiVietDetailSaga } from "./bai-viet/baiVietDetailSaga"
import { baiVietSaga } from "./bai-viet/baiVietSaga"
import { baiVietTrangThaiSaga } from "./bai-viet/baiVietTrangThaiSaga"
import { categorySourceSaga } from "./categorySourceSagas"
import { dgdkNlpcSaga } from "./danh-gia/dinh-ky/dgdkNlpcSaga"
import { dgtxKetQuaMonHocSaga } from "./danh-gia/thuong-xuyen/dgtxKetQuaMonHocSaga"
import { dgtxKetQuaSaga } from "./danh-gia/thuong-xuyen/dgtxKetQuaSaga"
import { hocKySaga } from "./danh-muc/hocKySaga"
import { lopSaga } from "./danh-muc/lopSaga"
import { plNamHocSaga } from "./danh-muc/plNamHocSaga"
import { thuSaga } from "./danh-muc/thuSaga"
import { tietSaga } from "./danh-muc/tietSaga"
import { tuanSaga } from "./danh-muc/tuanSaga"
import { dictionarySaga } from "./dictionarySagas"
import { diemDanhSaga } from "./diem-danh/diemDanhSaga"
import { diemDanhStatusSaga } from "./diem-danh/diemDanhStatusSaga"
import { giaoVienNhanXetSaga } from "./giaoVienNhanXetSaga"
import { giaoVienSaga } from "./giaoVienSaga"
import { hocSinhSelectionSaga } from "./hoc-sinh/hocSinhSelectionSaga"
import { localizedResourceSaga } from "./localized-resource/localizedResourcsSaga"
import { lopBoMonHocSinhSaga } from "./lop-bo-mon/lopBoMonHocSinhSaga"
import { lopBoMonListSaga } from "./lop-bo-mon/lopBoMonListSaga"
import { lopBoMonSoDiemSaga } from "./lop-bo-mon/lopBoMonSoDiemSaga"
import { lopHanhChinhSoDiemSaga } from "./lop-hanh-chinh/lopHanhChinhSoDiemSaga"
import { mappingSaga } from "./mapping/mappingSaga"
import { monHocSaga } from "./monHocSaga"
import { nhanXetHangNgaySaga } from "./nhan-xet/nhanXetHangNgaySaga"
import { nhapDiemSaga } from "./nhap-diem/nhapDiemSaga"
import { notifySaga } from "./notify/notifySaga"
import { loaiPhongSaga } from "./phong-hoc/loaiPhongSaga"
import { phongHocSaga } from "./phong-hoc/phongHocSaga"
import { soNhanXetItemSaga } from "./so-diem-tieu-hoc/soNhanXetItemSaga"
import { soNhanXetSaga } from "./so-diem-tieu-hoc/soNhanXetSaga"

import { appYeuCauHoTroSaga } from "./app-phuhuynh/appYeuCauHoTroSaga"
import { baiVietCommentSaga } from "./bai-viet-comment/baiVietCommentSaga"
import { baoCaoTienDoSaga } from "./bao-cao-tien-do/baoCaoTienDoSaga"
import { chamTietLoaiTietSaga } from "./cham-tiet/chamTietLoaiTietSaga"
import { chamTietSaga } from "./cham-tiet/chamTietSaga"
import { appConfigSaga } from "./common/appConfigSaga"
import { dgdkHocTapSaga } from "./danh-gia/dinh-ky/dgdkHocTapSaga"
import { thongTuSaga } from "./danh-muc/thongTuSaga"
import { ychtGroupSaga } from "./danh-muc/ychtGroupSaga"
import { diemVanMinhKetQuaSaga } from "./diemvanminh-ketqua/diemVanMinhKetQuaSaga"
import { diemVanMinhTieuChiSaga } from "./diemvanminh-tieuchi/diemVanMinhTIeuChiSaga"
import { gioCongDongSaga } from "./gio-cong-dong/gioCongDongSaga"
import { lopChuNhiemSaga } from "./lop-chu-nhiem/lopChuNhiemSaga"
import lopMonHocSaga from "./lop-mon-hoc/lopMonHocSaga"
import { thaiDoHocTapSaga } from "./nhan-xet/thaiDoHocTapSaga"
import { thaiDoHocTapTieuChiSaga } from "./nhan-xet/thaiDoHocTapTieuChiSaga"
import { giaiDoanSaga } from "./so-diem/giaiDoanSaga"
import { monHocSoDiemSaga } from "./so-diem/monHocSoDiemSaga"
import { nhomThanhPhanDiemSaga } from "./so-diem/nhomThanhPhanDiemSaga"
import { soDiemConfigSaga } from "./so-diem/soDiemCofigSaga"
import { soDiemListSaga } from "./so-diem/soDiemListSaga"
import { soDiemMappingSaga } from "./so-diem/soDiemMappingSaga"
import { thangDiemSaga } from "./so-diem/thangDiemSaga"
import { thanhPhanDiemSaga } from "./so-diem/thanhPhanDiemSaga"
import { thoiKhoaBieuChiTietSaga } from "./thoi-khoa-bieu/thoiKhoaBieuChiTietSaga"
import { thoiKhoaBieuSaga } from "./thoi-khoa-bieu/thoiKhoaBieuSaga"
import { thoiKhoaBieuViewSaga } from "./thoi-khoa-bieu/thoiKhoaBieuViewSaga"
import { toKhoiSaga } from "./toKhoiSaga"
import { tongHopDinhKySaga } from "./tong-hop/tongHopDinhKySaga"
import { uploadSaga } from "./upload-file/uploadSaga"
import { xepHangHocSinhSaga } from "./xep-hang-hoc-sinh/xepHangHocSinhSaga"
import { gioCongDongHoatDongSaga } from "./gio-cong-dong/gioCongDongHoatDongSaga"
import { cuocThaoLuanSaga } from "./cuoc-thao-luan/cuocThaoLuanSaga"
import { theoDoiRCSaga } from "./theo-doi-rc/theoDoiRCSaga"
import legalSaga from "./legal-document/legalSaga"
import danThuocSagaWrapper from "./danh-thuoc/danThuocSagaWrapper"
import { dgTuanKetQuaSaga } from "./danh-gia/tuan/dgTuanKetQuaSaga"
import { hoatDongHangNgaySaga } from "./danh-gia/hoatDongHangNgaySaga"
import { dotDanhGiaSaga } from "./danh-gia/dotDanhGiaSaga"
import { dotDanhGiaLopSaga } from "./danh-gia/dotDanhGiaLopSaga"
import { dotDanhGiaKetQuaSaga } from "./danh-gia/dotDanhGiaKetQuaSaga"



export default function* rootSaga() {
    yield all([
        authSaga(),
        dictionarySaga(),
        monHocSaga(),
        categorySourceSaga(),
        hocSinhSelectionSaga(),
        soDiemListSaga(),
        soDiemConfigSaga(),
        lopBoMonListSaga(),
        lopBoMonHocSinhSaga(),
        toKhoiSaga(),
        giaoVienSaga(),
        thanhPhanDiemSaga(),
        nhomThanhPhanDiemSaga(),
        giaiDoanSaga(),
        thangDiemSaga(),
        soNhanXetItemSaga(),
        giaoVienNhanXetSaga(),
        loaiPhongSaga(),
        phongHocSaga(),
        thuSaga(),
        tuanSaga(),
        tietSaga(),
        thoiKhoaBieuSaga(),
        thoiKhoaBieuChiTietSaga(),
        plNamHocSaga(),
        hocKySaga(),
        lopSaga(),
        uploadSaga(),
        appMenuSaga(),
        appMenuNhomSaga(),
        appMenuTruongSaga(),
        appAccountSaga(),
        baiVietSaga(),
        baiVietTrangThaiSaga(),
        baiVietDetailSaga(),
        appXinNghiSaga(),
        appYeuCauHoTroSaga(),
        notifySaga(),
        diemDanhSaga(),
        diemDanhStatusSaga(),
        nhanXetHangNgaySaga(),
        localizedResourceSaga(),
        baiTapTypeSaga(),
        baiTapSaga(),
        nhapDiemSaga(),
        monHocSoDiemSaga(),
        baiTapKetQuaSaga(),
        lopChuNhiemSaga(),
        baiTapKetQuaLopSaga(),
        lopBoMonSoDiemSaga(),
        mappingSaga(),
        soDiemMappingSaga(),
        thaiDoHocTapSaga(),
        thaiDoHocTapTieuChiSaga(),
        thongTuSaga(),
        thaiDoHocTapTieuChiSaga(),
        diemVanMinhTieuChiSaga(),
        diemVanMinhKetQuaSaga(),
        soNhanXetSaga(),
        dgdkNlpcSaga(),
        lopHanhChinhSoDiemSaga(),
        dgtxKetQuaSaga(),
        dgtxKetQuaMonHocSaga(),
        dgdkHocTapSaga(),
        baoCaoTienDoSaga(),
        xepHangHocSinhSaga(),
        lopMonHocSaga(),
        tongHopDinhKySaga(),
        baiVietCommentSaga(),
        appConfigSaga(),
        thoiKhoaBieuViewSaga(),
        chamTietSaga(),
        chamTietLoaiTietSaga(),
        ychtGroupSaga(),
        gioCongDongSaga(),
        gioCongDongHoatDongSaga(),
        cuocThaoLuanSaga(),
        theoDoiRCSaga(),
        legalSaga(),
        danThuocSagaWrapper(),
        dgTuanKetQuaSaga(),
        hoatDongHangNgaySaga(),
        dotDanhGiaSaga(),
        dotDanhGiaLopSaga(),
        dotDanhGiaKetQuaSaga()
    ])


}
